module.exports = __webpack_public_path__ + "img/area.ce468085.svg";